import React, { useEffect } from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';

const HomeRedirect = () => {
  const context = useOutletContext();
  const { user, isAuthenticated } = context || {};

  // Se l'utente è autenticato, reindirizza alla home con le tre card
  if (isAuthenticated && user) {
    return <Navigate to="/home" replace />;
  }

  // Se non è autenticato, mostra la pagina di login
  return <Navigate to="/login" replace />;
};

export default HomeRedirect;

